import React from "react";

function TodayFocasting({ forcastData, locationName, input, inputCountry }) {
  const dataFunction = (data) => {
    return new Date(data.current.dt * 1000).toLocaleString("en-ES", {
      timeZone: `${data.timezone}`,
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  };

  const TimeFunction = (data) => {
    return new Date(data.current.dt * 1000).toLocaleString("en-ES", {
      timeZone: `${data.timezone}`,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  if (!forcastData.current) {
    return <>Loading..</>;
  }
  return (
    <div className="text-center p-3">
      <div className="flex align-items-center justify-content-center primary-color mt-4">
        <img
          alt="weather Icon"
          src="./images/location.png"
          className="location-icon"
        />
        <h4 className="pl-2">
          {input && input ? input : locationName && locationName.city},
          <span className="country-heading">
            {inputCountry && inputCountry
              ? inputCountry
              : locationName && locationName.country_code}
          </span>
        </h4>
      </div>
      <div>
        {forcastData.current && (
          <img
            alt="weather Icon"
            src={`http://openweathermap.org/img/wn/${forcastData.current.weather[0].icon}@4x.png`}
          />
        )}
      </div>
      <div className="flex space-around align-items-center ">
        <div className="flex justify-content-center temp-color p-2">
          <h1 className="temp-font">
            {forcastData.current && Number(forcastData.current.temp).toFixed(0)}
            <sup className="temp-color">o</sup>
          </h1>
          <h4 className="ml-1 temp-degree ">C</h4>
        </div>
        <div className="flex">
          <img
            src="http://openweathermap.org/img/wn/10d.png"
            alt="weather Icon"
          />
          <div className="text-left">
            {/* <h4>Today</h4> */}
            <h4>{dataFunction(forcastData)}</h4>
            <p>
              {new Date(forcastData.current.dt * 1000).toLocaleString("en", {
                timeZone: `${forcastData.timezone}`,
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <h5>
          Feels like{" "}
          {forcastData.current && forcastData.current.feels_like.toFixed(0)}°C.
          {/* </h5>
        <h5> */}{" "}
          {forcastData.current && forcastData.current.weather[0].main}.
        </h5>
      </div>
      <div className="flex space-evenly mt-4">
        <div>
          <img
            alt="weather Icon"
            src="./images/sunrise.png"
            className="sun-icon"
          />
          <h4>
            {new Date(forcastData.current.sunrise * 1000).toLocaleString("en", {
              timeZone: `${forcastData.timezone}`,
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}

            {/* toLocaleString("en-ES", {
              timeZone: `${forcastData.timezone}`,
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })} */}
          </h4>
        </div>
        <div>
          <img
            alt="weather Icon"
            src="./images/sunset.png"
            className="sun-icon"
          />
          <h4>
            {new Date(forcastData.current.sunset * 1000).toLocaleString("en", {
              timeZone: `${forcastData.timezone}`,
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })}
          </h4>
        </div>
      </div>
      <div className="mt-6">
        <div className="flex space-between align-items-center mt-4 ml-4 mr-4">
          <div className="flex align-items-center">
            <img
              alt="weather Icon"
              src="./images/humidity.png"
              className="location-icon"
            />
            <h4 className="ml-3">Humidity</h4>
          </div>
          <div>
            <p>{forcastData.current && forcastData.current.humidity}%</p>
          </div>
        </div>
        <div className="flex space-between align-items-center mt-4 ml-4 mr-4">
          <div className="flex align-items-center">
            <img
              alt="weather Icon"
              src="./images/pressure.png"
              className="location-icon"
            />
            <h4 className="ml-3">Pressure</h4>
          </div>
          <div>
            <p>{forcastData.current && forcastData.current.pressure}hPa</p>
          </div>
        </div>
        <div className="flex space-between align-items-center mt-4 ml-4 mr-4">
          <div className="flex align-items-center">
            <img
              alt="weather Icon"
              src="./images/visible.png"
              className="location-icon"
            />
            <h4 className="ml-3">Visibility</h4>
          </div>
          <div>
            <p>{forcastData.current && forcastData.current.visibility}m</p>
          </div>
        </div>
        <div className="flex space-between align-items-center mt-4 ml-4 mr-4">
          <div className="flex align-items-center">
            <img
              alt="weather Icon"
              src="./images/wind.png"
              className="location-icon"
            />
            <h4 className="ml-3">Wind</h4>
          </div>
          <div className="flex align-items-center">
            <span>
              <img
                alt="weather Icon"
                src="/images/compass.png"
                className="compass-icon mt-1"
                style={{
                  transform: `rotate(${
                    forcastData.current && forcastData.current.wind_deg + 180
                  }deg)`,
                }}
              />
            </span>
            <p className="ml-2">
              {forcastData.current && forcastData.current.wind_speed}m/s
            </p>
          </div>
        </div>
        <div className="flex space-between align-items-center mt-4 ml-4 mr-4">
          <div className="flex align-items-center">
            <img
              alt="weather Icon"
              src="./images/dew.png"
              className="location-icon"
            />
            <h4 className="ml-3">Dew Point</h4>
          </div>
          <div>
            <p>
              {forcastData.current && forcastData.current.dew_point.toFixed(0)}
              °C
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TodayFocasting;
